<template>
    <div class="container">
        <section class="section projects">
            <h1>Company Project</h1>
            <div class="project-list">
                <div class="item"> 
                    <figure class="image">
                        <img class="project-thumb" src="../assets/toctoc_1.jpg">
                        <img class="project-thumb" src="../assets/toctoc_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">톡톡솔루션</h1>
                        <p class="desc">
                            매장에서 발급해주는 종이 쿠폰북을 온라인으로 전환한 서비스.<br>
                            <br>[참여 내역]<br>
                            해당 서비스를 이용하는 매장 현황 및 관리자 관리, 
                            매장들의 소셜 홍보를 위한 업로드 및 다양한 설정 관리 기능을 포함한 어드민 페이지 프론트엔드 개발 100% 참여.<br>
                            웹 랜딩페이지의 상담신청 부분 api 작업.
                        </p>
                        <a class="button" href="http://toctocsolution.kr/" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/flyingofbee_1.jpg">
                        <img class="project-thumb" src="../assets/flyingofbee_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">꿀벌의 비행</h1>
                        <p class="desc">
                            저소득층을 대상으로 후원하는 온라인 기부/모금 사이트.<br>
                            수혜자와 일반 유저에 따라 회원타입을 나누어 수혜자가 후원받고싶은 물건을 등록하면 일반 유저 혹은 기업이 모금액을 기부하는 방식.<br>
                            <br>[참여 내역]<br>
                            회원가입, SNS Login 및 수혜자 신청 파일 업로드, 일간/주간/월간 통계 그래프를 비롯한 유저페이지 프론트엔드 개발 50% 참여.<br>
                            수혜자 승인, 통계, 신고 관리, 배너/공지 등록 등을 포함한 어드민 페이지 프론트엔드 80% 개발.
                        </p>
                        <a class="button" href="https://www.kkoolbee.com/index" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item"> 
                    <figure class="image">
                        <img class="project-thumb" src="../assets/entpark_1.jpg">
                        <img class="project-thumb" src="../assets/entpark_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">엔팍</h1>
                        <p class="desc">
                            맛집, 펍, 페스티벌, 클럽 등 트렌디한 문화 컨텐츠를 예약 및 티켓으로 구매할 수 있는 웹 서비스.<br>
                            <br>[참여 내역]<br>
                            유저페이지 - 마이페이지, 결제 시 쿠폰 적용을 비롯한 일부 프론트엔드 개발 참여 및 운영<br>
                            어드민 - 매거진 등록/수정, 예약 요일별 설정 페이지 포함 프론트엔드 15% 참여
                        </p>
                        <a class="button" href="https://entpark.co.kr/kr" target="_blank">
                        <span>Visit Website</span><span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/g1230_1.jpg">
                        <img class="project-thumb" src="../assets/g1230_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">G1230</h1>
                        <p class="desc">
                            학원 수강생들을 대상으로 학년별/레벨별 영어 학습 및 테스트가 가능한 웹앱.<br>
                            <br>[참여 내역]<br>
                            회원가입/로그인, 학습 히스토리, 단계별 학습, 틀린 갯수 저장, 재시험, 힌트 보기 등이 가능하도록 
                            DB 설계 및 Node.js와 MySQL을 이용하여 API 설계.<br>
                            문제 은행 식의 학습 페이지는 Vue.js를 이용하여 SPA 형식으로 구성.<br>
                            사용자 페이지 및 관리자 페이지. 백엔드, 프론트엔드 100% 참여
                        </p>
                        <a class="button" href="http://hatnimsam.cafe24.com:16192/home/login" target="_blank"><span>Visit Website</span><span class="icon"><i class="fas fa-angle-right"></i></span></a>
                    </div>
                </div>
                <div class="item"> 
                    <figure class="image">
                        <img class="project-thumb" src="../assets/blinddate_1.jpg">
                        <img class="project-thumb" src="../assets/blinddate_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">블라인드데이트</h1>
                        <p class="desc">
                            모바일 기반의 지인 소개 및 승인제로만 가입할 수 있는 최초의 소셜 데이팅 앱.<br>
                            <br>[참여 내역]<br>
                            어드민 - 유저 프로필, 유저별 활동내역, 관리자 승인, 채팅 현황, 매칭 확률 설정 등 프론트엔드 80% 참여<br>
                            웹뷰 - 공지사항, FAQ, 개인정보취급방침, 이용약관 등 앱 내 웹뷰 작업.
                        </p>
                        <a class="button" href="https://play.google.com/store/apps/details?id=mars.nomad.com.blinddate2018" target="_blank">
                        <span>Visit Website</span><span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/spep_1.jpg">
                        <!-- <img class="project-thumb" src="../assets/SPEP-1.jpg"> -->
                    </figure>
                    <div class="text">
                        <h1 class="title">SPEP</h1>
                        <p class="desc">
                            직장인을 위한 영어교육업체(SPEP)의 교육시스템 모바일 앱.<br>
                            회원타입에 따라 학생, 강사, QM, Manager 4가지 앱으로 분리되며 <br>
                            관리자 페이지는 운영(총괄), 강사, QM, R&D, 정산, 콘텐츠 빌더 6가지로 구분.<br>
                            <br>[참여 내역]<br>
                            어드민 - 고객 기업 및 수강생 관리, 클래스 생성, 타임 테이블, 수업 변경, 강사 및 QM 평가 등 
                            모바일 앱에 적용되는 데이터들을 설정하고 총괄 가능.<br>
                            각 타입의 유저는 다른 타입의 관리자에 접근 불가하도록 처리.<br>
                            관리자 페이지 및 웹뷰를 포함하여 프론트엔드 70% 참여<br>
                        </p>
                        <a class="button" href="https://play.google.com/store/apps/details?id=mars.nomad.com.scep_2018" target="_blank"><span>Visit Website</span><span class="icon"><i class="fas fa-angle-right"></i></span></a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/citadine_1.jpg">
                        <img class="project-thumb" src="../assets/citadine_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">시타딘 한리버 서울</h1>
                        <p class="desc">
                            애스콧 산하의 시타딘 호텔 서울 지점의 숙박 예약이 가능한 웹 사이트.<br>
                            <br>[참여 내역]<br>
                            날씨, 지도 api 등을 활용하였고, jQuery의 DatePicker 모듈을 커스터마이징 하여 숙박 날짜 선택 시 편의성을 고려해 여러 예외처리를 두어 개발.<br>
                            미디어 쿼리를 이용한 반응형 웹.<br>
                            예약 및 게시판의 데이터베이스가 필요한 부분을 제외한 모든 마크업 100% 개발.
                        </p>
                        <a class="button" href="http://www.citadineshanriverseoul.co.kr/" target="_blank"><span>Visit Website</span><span class="icon"><i class="fas fa-angle-right"></i></span></a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/central_1.jpg">
                        <img class="project-thumb" src="../assets/central_2.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">Central</h1>
                        <p class="desc">
                            자동차 부품 기업 센트랄 홈페이지 구축.<br>
                            <br>[참여 내역]<br>
                            각 페이지 동영상 삽입 및 css 트랜지션, 애니메이션 사용. 미디어 쿼리를 이용한 반응형 웹.<br>
                            트래픽 분석을 위해 구글 애널리틱스를 사용하였고, php와 ajax를 이용한 비동기 통신으로 데이터 전송.<br>
                            마크업 100% 개발 및 호스팅 서버 운영.
                        </p>
                        <a class="button" href="http://www.ctr.co.kr/" target="_blank"><span>Visit Website</span><span class="icon"><i class="fas fa-angle-right"></i></span></a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style>
/* project list styling */
.project-list .item {
	overflow: hidden;
	margin-bottom: 30px;
	border-bottom: 1px solid #eee;
	max-width: 700px;
	margin: 0 auto;
}
.project-list .item:last-child {
	border-bottom: none;
}
.project-list .image {
	margin: 0 auto;
	text-align: center;
}
.project-list .image .project-thumb {
	width: 250px;
	margin: 20px;
	box-shadow: 0 4px 6px rgba(50, 50, 93, 0.2), 0 1px 3px rgba(0, 0, 0, 0.15);
}
.project-list .text {
	text-align: center;
	padding: 20px;
}
.project-list .text .title {
	font-size: 1.2rem;
	color: #333;
	margin-bottom: 20px;
}
.project-list .text .desc {
	margin-bottom: 20px;
	font-weight: lighter;
	line-height: 1.3;
}
.project-list .text .button {
	display: inline-block;
	padding: 9px 14px;
	border: 1px solid #42b883;
	color: #42b883;
	text-decoration: none;
	border-radius: 20px;
}
.project-list .text .button:hover {
	background-color: #42b883;
	color: white;
}
.project-list .text .button .icon {
	margin-left: 5px;
}
</style>
